export enum PaymentType {
  UNTIL_PAID = 'UNTIL_PAID',
  TRIAL = 'TRIAL',
  REGULAR = 'REGULAR',
}
